import {
  FreightQuoteRequestSchema,
  FreightQuoteSchema,
} from "@redotech/redo-model/freight/freight-quote-request";
import * as z from "zod/v4";

export const generateFreightQuotes = {
  name: "generateFreightQuotes" as const,
  input: FreightQuoteRequestSchema,
  output: z.array(FreightQuoteSchema),
};
